import { render, staticRenderFns } from "./HomeBlockList.vue?vue&type=template&id=0c32b531&scoped=true&"
import script from "./HomeBlockList.vue?vue&type=script&lang=js&"
export * from "./HomeBlockList.vue?vue&type=script&lang=js&"
import style0 from "./HomeBlockList.vue?vue&type=style&index=0&id=0c32b531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c32b531",
  null
  
)

export default component.exports